import axios from 'axios';
import { BASE_URL } from './apiconfig';

export const getMyPromos = async (token: string | null, params: string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/promos/my?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to fetch my promos. ", error);
    throw error;
  }
}

export const getPromos = async (token: string | null, params: string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/promos?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to fetch promos. ", error);
    throw error;
  }
}

export const getPromoById = async (token: string | null, id: number) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/promos/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to fetch promo. ", error);
    throw error;
  }
}

export const createPromoApi = async (token: string | null, promoInfo: {
  title: string,
  body: string,
  image_key?: string | null,
  url?: string | null,
  button_label?: string | null,
  start_date?: string | null,
  end_date?: string | null,
  frequency?: number | null,
  dealer_ids: number[],
  is_draft: boolean | null
}) => {
  try {
    const response = await axios.post(`${BASE_URL}/promos`, promoInfo, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.log("Failed to create promo. ", error);
    throw error;
  }
}

export const updatePromoApi = async (token: string | null, id: number, promoInfo: any) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/promos/${id}`, promoInfo, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to update promo. ", error);
    throw error;
  }
}

export const deletePromoApi = async (token: string | null, id: number) => {
  try {
    const { data } = await axios.delete(`${BASE_URL}/promos/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to delete promo. ", error);
    throw error;
  }
}

